(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1FBxg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1376bc92f02b5b83$export$2e2bcd8739ae039; });

var $26bsd = parcelRequire("26bsd");
var $1376bc92f02b5b83$var$debounce = function(callback, wait) {
    var timeoutId = null;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(function() {
            callback.apply(void 0, (0, $26bsd._)(args));
        }, wait);
    };
};
var $1376bc92f02b5b83$export$2e2bcd8739ae039 = $1376bc92f02b5b83$var$debounce;

});
parcelRegister("26bsd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $187506d5b1cfb700$export$71511d61b312f219; });

var $afUn2 = parcelRequire("afUn2");

var $giCaB = parcelRequire("giCaB");

var $220cd = parcelRequire("220cd");

var $aCRvb = parcelRequire("aCRvb");
function $187506d5b1cfb700$export$71511d61b312f219(arr) {
    return (0, $afUn2._)(arr) || (0, $giCaB._)(arr) || (0, $aCRvb._)(arr) || (0, $220cd._)();
}

});
parcelRegister("afUn2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7777081c2a4b1a86$export$71511d61b312f219; });

var $IChKS = parcelRequire("IChKS");
function $7777081c2a4b1a86$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $IChKS._)(arr);
}

});
parcelRegister("IChKS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0861ceda66c08a50$export$71511d61b312f219; });
function $0861ceda66c08a50$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("giCaB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bddbef8d2db60240$export$71511d61b312f219; });
function $bddbef8d2db60240$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("220cd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $17abeb9ade6216e7$export$71511d61b312f219; });
function $17abeb9ade6216e7$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("aCRvb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7bc6f45e6716f784$export$71511d61b312f219; });

var $IChKS = parcelRequire("IChKS");
function $7bc6f45e6716f784$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $IChKS._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $IChKS._)(o, minLen);
}

});



parcelRegister("i5wGC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2b20c771fe6494c$export$2e2bcd8739ae039; });
var $d2b20c771fe6494c$var$throttle = function throttle(callback, limit) {
    var waiting = false;
    return function() {
        if (!waiting) {
            // eslint-disable-next-line prefer-rest-params
            callback.apply(this, arguments);
            waiting = true;
            setTimeout(function() {
                waiting = false;
            }, limit);
        }
    };
};
var $d2b20c771fe6494c$export$2e2bcd8739ae039 = $d2b20c771fe6494c$var$throttle;

});

parcelRegister("cfDUW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eb5d989c6289577$export$2e2bcd8739ae039; });
/**
 * Fire function on DOM ready
 *
 * This implementation is coming from https://gomakethings.com/a-native-javascript-equivalent-of-jquerys-ready-method/
 *
 * @param {Function} fn Callback function to run.
 */ var $8eb5d989c6289577$var$onReady = function(fn) {
    if (typeof fn !== 'function') return;
    if (document.readyState === 'interactive' || document.readyState === 'complete') return fn();
    document.addEventListener('DOMContentLoaded', fn, false);
};
var $8eb5d989c6289577$export$2e2bcd8739ae039 = $8eb5d989c6289577$var$onReady;

});

/* eslint-disable import/no-unresolved */ /**
 * Load front-end scripts and styling common the the entire theme.
 */ /**
 * Core/global configurations
 */ 
var $bab0b43034f4769a$exports = {};
var $0fafdd97379366e0$exports = {};
/**
 * Auto Height JavaScript
 *
 * This file defines Auto Height
 * behavior.
 */ /**
 * Allow animation to height:auto
 *
 * Useful e.g. for accordions: this measures an element's
 * height, then adds a --h-auto variable to that element's
 * parent. That way, you can animate to --h-auto rather than
 * height:auto (which doesn't work). Applying height to the parent
 * rather than the element itself ensures padding also gets collapsed
 *
 * @param {string} selector Selector to measure (applies style to parent)
 */ // import dependencies

var $1FBxg = parcelRequire("1FBxg");
var $bb900de31ae66bb9$export$374f74bb62f0e88d = function(selector) {
    // get all the auto height elements
    var els = document.querySelectorAll(selector);
    // if we have some elements
    if (els.length) {
        // handle setting height to auto then resetting to actual calculated height on parent
        var setHeights = function() {
            els.forEach(function(el) {
                el.parentElement.style.setProperty('--h-auto', "auto");
                el.parentElement.style.setProperty('--h-auto', "".concat(el.offsetHeight, "px"));
            });
        };
        // set heights right away
        setHeights();
        // on load reset heights (useful for slow-loading assets like video)
        window.addEventListener('load', (0, $1FBxg.default)(setHeights, 100));
        // on resize wait a moment (for performance) then reset heights
        window.addEventListener('resize', (0, $1FBxg.default)(setHeights, 100));
    }
};


(0, $bb900de31ae66bb9$export$374f74bb62f0e88d)('.has-auto-height, .wp-block-cover.ani--parallax');


var $ee0948661e41e69f$exports = {};
/**
 * Animation Disabler JavaScript
 *
 * This file defines Animation Disabler
 * behavior.
 */ 
var $i5wGC = parcelRequire("i5wGC");
var $ee0948661e41e69f$var$timer = null;
window.addEventListener('resize', (0, $i5wGC.default)(function() {
    document.body.classList.add('ani--disable');
    clearTimeout($ee0948661e41e69f$var$timer);
    $ee0948661e41e69f$var$timer = setTimeout(function() {
        document.body.classList.remove('ani--disable');
    }, 250);
}, 100));


var $00df1c68d74a958b$exports = {};
/**
 * Background attachment fixed fix
 *
 * background-attachment:fixed doesn't work
 * on iOS, so we're doing our best to detect such
 * browsers and defaulting to background-attachment:scroll.
 */ var $00df1c68d74a958b$var$_document_querySelectorAll;
($00df1c68d74a958b$var$_document_querySelectorAll = document.querySelectorAll('.has-parallax')) === null || $00df1c68d74a958b$var$_document_querySelectorAll === void 0 ? void 0 : $00df1c68d74a958b$var$_document_querySelectorAll.forEach(function(el) {
    var styles = getComputedStyle(el);
    if (styles.getPropertyValue('background-attachment') === 'fixed') {
        var iOSMaybe = [
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform) || navigator.userAgent.includes('Mac') && 'ontouchend' in document;
        if (iOSMaybe) el.style.setProperty('background-attachment', 'scroll');
    }
});


var $782a0515eb46a58b$exports = {};
/**
 * Set up menu behavior
 */ /**
 * Get dependencies
 */ 
var $26bsd = parcelRequire("26bsd");

var $i5wGC = parcelRequire("i5wGC");

var $cfDUW = parcelRequire("cfDUW");
/**
 * Set up main menu.
 */ var $782a0515eb46a58b$var$menuEl = document.getElementById('menu-main-wrap');
var $782a0515eb46a58b$var$mainMenu = function(wrap) {
    if (wrap) {
        // grab the sub elements
        var triggers = [
            wrap.querySelector('.js-menu-main-trigger')
        ];
        var menu = triggers[0].nextElementSibling;
        // add the close button
        var closeToggle = document.createElement('button');
        triggers.push(closeToggle);
        closeToggle.classList.add('menu-main-close', 'js-menu-main-trigger');
        closeToggle.textContent = 'Close';
        wrap.appendChild(closeToggle);
        // start out with the nav hidden at mobile
        if (window.getComputedStyle(menu).bottom !== 'auto') menu.setAttribute('aria-hidden', true);
        // for each trigger
        triggers.forEach(function(trigger) {
            // add accessibility
            trigger.setAttribute('aria-expanded', false);
            trigger.setAttribute('aria-controls', menu.id);
            // on click of the trigger show the menu (with accessibility)
            trigger.addEventListener('click', function() {
                var wasOpen = trigger.getAttribute('aria-expanded') === 'true';
                triggers.forEach(function(el) {
                    el.setAttribute('aria-expanded', !wasOpen);
                    el.setAttribute('aria-label', wasOpen ? 'Menu' : 'Close');
                    el.classList.add('ani-hack');
                    setInterval(function() {
                        el.classList.remove('ani-hack');
                    }, 300);
                });
                menu.setAttribute('aria-hidden', wasOpen);
                document.body.classList.toggle('menu-main-active', !wasOpen);
            });
        });
        // for nav items (li) with sub menus
        menu.querySelectorAll('.menu-item-has-children').forEach(function(li) {
            // cache elements
            var subMenu = li.querySelector('.sub-menu');
            var subMenuId = "".concat(li.getAttribute('id'), "-sub");
            // make li elements tab/clickable in control of subnav
            li.setAttribute('tabindex', '0');
            li.setAttribute('role', 'button');
            li.setAttribute('aria-controls', subMenuId);
            li.setAttribute('aria-expanded', false);
            // allow "enter" keydown to activate li for accessibility
            li.addEventListener('keydown', function(e) {
                if (e.keyCode === 13 && li === document.activeElement) li.click();
            });
            // identify subnav as being hidden
            subMenu.setAttribute('id', subMenuId);
            subMenu.setAttribute('aria-hidden', true);
            // expand/contract sub nav
            var toggleActive = function(e) {
                e.stopPropagation();
                // if we're expanding
                var isExpanding = li.getAttribute('aria-expanded') !== 'true';
                if (isExpanding) // first find and close this and all peers with sub items
                li.parentElement.querySelectorAll('.menu-item-has-children').forEach(function(el) {
                    el.setAttribute('aria-expanded', false);
                    el.lastElementChild.setAttribute('aria-hidden', true);
                });
                // expand/contract this sub nav
                li.setAttribute('aria-expanded', isExpanding);
                subMenu.setAttribute('aria-hidden', !isExpanding);
            };
            // bind the events
            li.addEventListener('click', toggleActive);
        });
    }
};
// send it!
$782a0515eb46a58b$var$mainMenu($782a0515eb46a58b$var$menuEl);
/**
 * Set up main menu mobile/desktop styling
 */ var $782a0515eb46a58b$var$responsiveMenu = function(wrap) {
    if (wrap) {
        var menu = wrap.querySelector('#menu-main');
        var links = (0, $26bsd._)(wrap.querySelectorAll('#menu-main > li'));
        var setMenuSize = function() {
            wrap.classList.remove('is-mobile');
            var isMobile = menu.offsetWidth - 10 <= links.reduce(function(a, b) {
                return a + b.offsetWidth;
            }, 0);
            wrap.classList.toggle('is-mobile', isMobile);
        };
        (0, $cfDUW.default)(function() {
            setMenuSize();
            wrap.classList.add('is-loaded');
        });
        window.addEventListener('load', setMenuSize);
        window.addEventListener('resize', (0, $i5wGC.default)(setMenuSize, 300));
    }
};
// send it!
$782a0515eb46a58b$var$responsiveMenu($782a0515eb46a58b$var$menuEl);


var $6535c46fae0c7074$exports = {};
/* eslint-disable no-plusplus */ /**
 * Set up tabs
 *
 * Sets up accessibility and behavior for tabs. Can work with either
 * one list of label toggles, or multiple (e.g. if goes from a tab
 * nav to an accordion at mobile).
 *
 * Example:

tabs('my-tabs', { // slug
	expandFirstTab: true, // on load pre-expand first tab
	oneAlwaysOpen: true, // dont collapse open tabs on click
	selectors: {
		wrap: '.my-tabs', // main wrapper containing all tab features
		toggles: ['.my-tabs__button--desk', '.my-tabs__button--mobile'], // string for one trigger or array for multiple
		content: '.tabs-item__content', // content area that gets expanded
	},
})

 *
 */ // we're using window.xyz to make this globally available to blocks
window.aquaminTabs = function(name, opt) {
    var tabWraps = document.querySelectorAll(opt.selectors.wrap);
    if (tabWraps) tabWraps.forEach(function(tab, i) {
        var _loop = function(j) {
            // set up this particular iteration's ID
            var subId = "".concat(id, "-").concat(j);
            // apply accessibility to content
            content[j].setAttribute('id', subId);
            content[j].setAttribute('aria-hidden', opt.expandFirstTab ? !!j : true);
            content[j].setAttribute('role', 'tabpanel');
            content[j].setAttribute('tabindex', opt.expandFirstTab && !j ? 0 : -1);
            // set up the toggle(s)
            togglesArr.forEach(function(toggles, ij) {
                var toggleId = "".concat(toggles.sluggish, "-").concat(subId);
                toggles.el[j].setAttribute('id', toggleId);
                toggles.el[j].setAttribute('role', 'tab');
                toggles.el[j].setAttribute('aria-controls', "".concat(subId));
                toggles.el[j].setAttribute('aria-selected', opt.expandFirstTab ? !j : false);
                toggles.el[j].addEventListener('click', function() {
                    return setTab(j);
                });
                // only set labelledby of content based on first controls found (index 0)
                if (!ij) content[j].setAttribute('aria-labelledby', toggleId);
            });
        };
        // set up content sections
        var id = "".concat(name, "-").concat(i);
        var content = tab.querySelectorAll(opt.selectors.content);
        var amount = content.length;
        // set up toggles
        var togglesArr = [];
        var toggleSelectors = typeof opt.selectors.toggles === 'string' ? [
            opt.selectors.toggles
        ] : opt.selectors.toggles;
        toggleSelectors.forEach(function(toggleSelector) {
            var sluggish = toggleSelector.replace(/[^a-zA-Z ]/g, '');
            togglesArr.push({
                sluggish: sluggish,
                el: tab.querySelectorAll(toggleSelector)
            });
        });
        // handle clicks
        var setTab = function(index) {
            togglesArr.forEach(function(toggles) {
                toggles.el.forEach(function(el, j) {
                    var inactive = opt.oneAlwaysOpen ? true : el.getAttribute('aria-selected') === 'false';
                    el.setAttribute('aria-selected', false);
                    if (j === index && inactive) el.setAttribute('aria-selected', true);
                });
            });
            content.forEach(function(el, j) {
                var inactive = opt.oneAlwaysOpen ? true : el.getAttribute('aria-hidden') === 'true';
                el.setAttribute('aria-hidden', true);
                el.setAttribute('tabindex', -1);
                if (j === index && inactive) {
                    el.setAttribute('aria-hidden', j !== index);
                    el.setAttribute('tabindex', 0);
                }
            });
        };
        // loop each item using content number as assumed amount
        for(var j = 0; j < amount; j++)_loop(j);
        // identify this as tabs
        var toggleIdsArr = [];
        togglesArr === null || togglesArr === void 0 ? void 0 : togglesArr.forEach(function(toggles) {
            toggles.el.forEach(function(toggle) {
                toggleIdsArr.push(toggle.id);
            });
        });
        if (toggleIdsArr.length) {
            tab.setAttribute('role', 'tablist');
            tab.setAttribute('aria-owns', toggleIdsArr.join(' '));
        }
    });
};


var $93ecb112604d2232$exports = {};
/**
 * Toggle JavaScript
 *
 * Add accessibility and define drop
 * down behavior
 */ // we're using window.xyz to make this globally available to blocks
window.aquaminToggle = function(name, opt) {
    var _document_querySelectorAll;
    (_document_querySelectorAll = document.querySelectorAll(opt.wrap)) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.forEach(function(wrap, i) {
        // define unique id prefix
        var id = "".concat(name, "-").concat(i);
        // get sub elements
        var triggers = wrap.querySelectorAll(opt.triggers);
        var menu = wrap.querySelector(opt.menu);
        // add accessibility to menu
        menu.setAttribute('id', "".concat(id, "-menu"));
        // start out with nav hidden at mobile (assumes trigger is only visible at mobile)
        if (triggers[0].offsetParent) menu.setAttribute('aria-hidden', true);
        // for each trigger
        triggers.forEach(function(trigger) {
            // add accessibility to this trigger
            trigger.setAttribute('aria-expanded', false);
            trigger.setAttribute('aria-controls', menu.id);
            // on click of the trigger show the menu (with accessibility)
            trigger.addEventListener('click', function() {
                var wasOpen = trigger.getAttribute('aria-expanded') === 'true';
                triggers.forEach(function(el) {
                    el.setAttribute('aria-expanded', !wasOpen);
                    el.setAttribute('aria-label', wasOpen ? 'Menu' : 'Close');
                });
                menu.setAttribute('aria-hidden', wasOpen);
            });
        });
    });
};


$bab0b43034f4769a$exports = {
    "auto-height": {
        "auto-height-": $0fafdd97379366e0$exports
    },
    "animation-disabler": {
        "animation-disabler-": $ee0948661e41e69f$exports
    },
    "background-attachment-fixed": {
        "background-attachment-fixed-": $00df1c68d74a958b$exports
    },
    "menu": {
        "menu-": $782a0515eb46a58b$exports
    },
    "tabs": {
        "tabs-": $6535c46fae0c7074$exports
    },
    "toggle": {
        "toggle-": $93ecb112604d2232$exports
    }
};


var $1a1177bb48747019$exports = {};












$1a1177bb48747019$exports = {
    "animation-disabler": {
        "animation-disabler-": {}
    },
    "frame-overlay": {
        "frame-overlay-": {}
    },
    "footer": {
        "footer-": {}
    },
    "menu": {
        " menu-sticky-": {},
        "menu-": {},
        "menu-trigger-": {}
    },
    "parallax-group": {
        "parallax-group-": {}
    },
    "scrollable-feed": {
        "scrollable-feed-": {}
    },
    "title-button-pair": {
        "title-button-pair-": {}
    },
    "vertical-heading": {
        "vertical-heading-": {}
    },
    "wp-forms": {
        "wp-forms-": {}
    },
    "wp-overrides": {
        "wp-": {}
    }
};




})();
//# sourceMappingURL=theme.bundle.js.map
